import { useState } from 'react';
import { format, addMonths, subMonths } from 'date-fns';
import { useFetchAvailableTimeslots } from './useFetchAvailableTimeslots';
import { useFetchAvailableDates } from './useFetchAvailableDates';

import { DateInput, DateInputDaySelectedState } from 'src/types/DateInput';

export const useBookingLogic = () => {
  const today = new Date();

  const [date, setDate] = useState<DateInput>({
    day: null,
    month: today.getMonth(),
    year: today.getFullYear(),
  });

  console.log('date:', date); // returns date: {day: null, month: 0, year: 2026}

  const toggleMonth = (newDate: Date) => {
    setDate({
      day: null,
      month: newDate.getMonth(),
      year: newDate.getFullYear(),
    });
    setTime(null);
  };

  const [time, setTime] = useState<string | null>(null);
  const { availableDates, loadingAvailableDates } = useFetchAvailableDates(
    date.day,
    date.month,
    date.year,
    toggleMonth,
  );
  const dateIsAvailable = availableDates.includes(date.day || 0);

  const { availableTimeslots, loadingTimeslots, error } =
    useFetchAvailableTimeslots(date, dateIsAvailable);

  const timeslotIsAvailable = !!time && availableTimeslots.includes(time);

  const selectDay = (day: number) => {
    console.log('did run select day');
    setDate((prev) => ({ ...prev, day }));
  };

  const selectTime = (selectedTime: string | null) => {
    setTime(selectedTime);
  };

  const resetBooking = () => {
    setDate({
      day: null,
      month: today.getMonth(),
      year: today.getFullYear(),
    });
    setTime(null);
  };

  return {
    date,
    time,
    timeslotIsAvailable,
    loadingTimeslots,
    loadingAvailableDates,
    error,
    availableTimeslots,
    availableDates,
    selectDay,
    selectTime,
    toggleMonth,
    resetBooking,
  };
};
